import React from "react";

import classes from "./advertisementPage.module.css";
import { AdvertisementFilterPage } from "./advertisementFilter/AdvertisementFilterPage";
import { AdvertisementTablePage } from "./advertisementTable/AdvertisementTablePage";

export const AdvertisementListPage = () => {
  return (
    <div className={classes.box}>
      <AdvertisementFilterPage />
      <AdvertisementTablePage />
    </div>
  );
};
